import localesGql from "../graphql/locales/locales";
import apolloClient from "../plugins/apolloClient";
import { ApolloClient } from "@apollo/client/core";
import { FetchedLocale, FormattedLocales } from "../types/locales";
import localesMapper from "../mappers/localesMapper";
import { notifyErrorFromResponse } from "../utils/notify";

export interface LocalesResponse {
  allLocales: FetchedLocale[];
}

export class LocalesApi {
  constructor(private readonly apolloClient: ApolloClient<object>) {}

  public async getLocales(keys: string[]): Promise<FormattedLocales> {
    const response = await this.apolloClient.query<LocalesResponse>({
      query: localesGql,
      variables: {
        keys,
      },
    });

    if (response.errors) {
      notifyErrorFromResponse(response.errors);
    }

    return localesMapper(response.data.allLocales);
  }
}

const localesApi = new LocalesApi(apolloClient);

export default localesApi;
